import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const CaddyCardContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `};
  width: 154px;
`;

export const RodConfigCardStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
  py: { sm: '200' },
  px: { sm: '400' },
  mx: { sm: '100' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[200]};
    border: dashed 1px ${theme.colors.grey[300]};
  `};
`;
